import MetalNImage from "@/images/metal_n@2x.png";
import MetalRImage from "@/images/metal_r@2x.png";
import MetalVImage from "@/images/metal_v@2x.png";
import MetalYImage from "@/images/metal_y@2x.png";
import MetalZImage from "@/images/metal_z@2x.png";
import MetalZAImage from "@/images/metal_za@2x.png";
import MetalAKImage from "@/images/metal_ak@2x.png";
import MetalALImage from "@/images/metal_al@2x.png";
import MetalAMImage from "@/images/metal_am@2x.png";
import MetalANImage from "@/images/metal_an@2x.png";

export default [
  {
    shape: "大福",
    name: "大福",
    code: "N",
    imagePath: MetalNImage,
    accessory: [1, 2, 3, 4],
    way: ["A", "B", "C"],
    textSetting: {
      templeName: {
        lineLimit: 1,
        textLimit: 10,
        maxFontsize: 25,
      },
      godName: {
        lineLimit: 2,
        textLimit: 10,
        maxFontsize: 50,
      },
      gift: {
        lineLimit: 2,
        textLimit: 12,
        maxFontsize: 20,
      },
    },
    engravingContentType: "default",
  },
  {
    shape: "大福",
    name: "大福九品蓮",
    code: "R",
    imagePath: MetalRImage,
    accessory: [1, 2, 3, 4],
    way: ["A", "B", "C"],
    textSetting: {
      templeName: {
        lineLimit: 1,
        textLimit: 10,
        maxFontsize: 25,
      },
      godName: {
        lineLimit: 2,
        textLimit: 10,
        maxFontsize: 50,
      },
      gift: {
        lineLimit: 2,
        textLimit: 12,
        maxFontsize: 20,
      },
    },
    engravingContentType: "default",
  },
  {
    shape: "大福",
    name: "祥龍獻福",
    code: "V",
    imagePath: MetalVImage,
    accessory: [1, 2, 3, 4],
    way: ["A", "B", "C"],
    textSetting: {
      templeName: {
        lineLimit: 1,
        textLimit: 10,
        maxFontsize: 25,
      },
      godName: {
        lineLimit: 2,
        textLimit: 10,
        maxFontsize: 50,
      },
      gift: {
        lineLimit: 2,
        textLimit: 12,
        maxFontsize: 20,
      },
    },
    engravingContentType: "default",
  },
  {
    shape: "大福",
    name: "大龍大福",
    code: "Y",
    imagePath: MetalYImage,
    accessory: [1, 2, 3, 4],
    way: ["A", "B", "C"],
    textSetting: {
      templeName: {
        lineLimit: 1,
        textLimit: 10,
        maxFontsize: 25,
      },
      godName: {
        lineLimit: 2,
        textLimit: 10,
        maxFontsize: 50,
      },
      gift: {
        lineLimit: 1,
        textLimit: 12,
        maxFontsize: 20,
      },
    },
    engravingContentType: "default",
  },
  {
    shape: "大福",
    name: "大福道",
    code: "Z",
    imagePath: MetalZImage,
    accessory: [1, 2, 3, 4],
    way: ["A", "B", "C"],
    textSetting: {
      templeName: {
        lineLimit: 1,
        textLimit: 10,
        maxFontsize: 25,
      },
      godName: {
        lineLimit: 2,
        textLimit: 10,
        maxFontsize: 50,
      },
      gift: {
        lineLimit: 2,
        textLimit: 12,
        maxFontsize: 20,
      },
    },
    engravingContentType: "default",
  },
  {
    shape: "大福",
    name: "大統帥",
    code: "ZA",
    imagePath: MetalZAImage,
    accessory: [1, 2, 3, 4],
    way: ["A", "B", "C"],
    textSetting: {
      templeName: {
        lineLimit: 1,
        textLimit: 10,
        maxFontsize: 25,
      },
      godName: {
        lineLimit: 2,
        textLimit: 10,
        maxFontsize: 50,
      },
      gift: {
        lineLimit: 2,
        textLimit: 12,
        maxFontsize: 20,
      },
    },
    engravingContentType: "default",
  },
  {
    shape: "大福",
    name: "鴻福",
    code: "AK",
    imagePath: MetalAKImage,
    accessory: [1, 2, 3, 4],
    way: ["A", "B", "C"],
    textSetting: {
      templeName: {
        lineLimit: 1,
        textLimit: 10,
        maxFontsize: 25,
      },
      godName: {
        lineLimit: 2,
        textLimit: 10,
        maxFontsize: 50,
      },
      gift: {
        lineLimit: 1,
        textLimit: 12,
        maxFontsize: 16,
      },
    },
    engravingContentType: "default",
  },
  {
    shape: "大福",
    name: "天福",
    code: "AL",
    imagePath: MetalALImage,
    accessory: [1, 2, 3, 4],
    way: ["A", "B", "C"],
    textSetting: {
      templeName: {
        lineLimit: 1,
        textLimit: 10,
        maxFontsize: 25,
      },
      godName: {
        lineLimit: 2,
        textLimit: 8,
        maxFontsize: 50,
      },
      gift: {
        lineLimit: 2,
        textLimit: 13,
        maxFontsize: 20,
      },
    },
    engravingContentType: "default",
  },
  {
    shape: "大福",
    name: "龍鳳圓福",
    code: "AM",
    imagePath: MetalAMImage,
    accessory: [1, 2, 3, 4],
    way: ["A", "B", "C"],
    textSetting: {
      templeName: {
        lineLimit: 1,
        textLimit: 8,
        maxFontsize: 25,
      },
      godName: {
        lineLimit: 2,
        textLimit: 8,
        maxFontsize: 50,
      },
      gift: {
        lineLimit: 2,
        textLimit: 13,
        maxFontsize: 20,
      },
    },
    engravingContentType: "default",
  },
  {
    shape: "大福",
    name: "雙福",
    code: "AN",
    imagePath: MetalANImage,
    accessory: [1, 2, 3, 4],
    way: ["A", "B", "C"],
    textSetting: {
      templeName: {
        lineLimit: 1,
        textLimit: 10,
        maxFontsize: 25,
      },
      godName: {
        lineLimit: 2,
        textLimit: 10,
        maxFontsize: 50,
      },
      gift: {
        lineLimit: 2,
        textLimit: 13,
        maxFontsize: 20,
      },
    },
    engravingContentType: "default",
  },
];
